var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.lvl0),function(value){return _c('p',{key:value},[_vm._v(" "+_vm._s(value)+" ("+_vm._s(_vm.filteredTreeFacet(value))+") ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }